import camelCase from 'camelcase';

import { FilingTypeApiData, FilingTypeDataItem, UserExperience } from '@api/filingTypes';
import { parseRegDate } from '@models/Registrations/helpers';

import { formatFilingDate, formatPeriodicity } from './helpers';

/**
 * Transforms API data into a list of filing types for a given registration
 */
export const filingTypesGetModel = (
  filingTypes = [] as Array<FilingTypeApiData>,
  userExperiences = {} as UserExperience
): { data: Array<FilingTypeDataItem> } => ({
  data: filingTypes.map(type => {
    const userExperienceId = camelCase(type.userExperience as string);

    return {
      id: type.id,
      periodId: type.period,
      registrationType: type.registrationSubTypeDisplay,
      type: type.periodDetail?.filingType?.nameLong,
      typeId: type.periodDetail?.filingType?.id,
      submissionPeriod: `${type.periodDetail?.filingPeriod}${
        type.periodDetail?.comment ? ` (${type.periodDetail?.comment})` : ''
      }`,
      dayDue: type.dayMonth,
      periodicity: formatPeriodicity(type.endingMonths),
      endingMonths: type.endingMonths,
      startDateDisplay: formatFilingDate(type.dateFilingStart),
      startDate: parseRegDate(type.dateFilingStart),
      isAuto: type.periodDetail?.isAutomaticallyCreated,
      userExperience: {
        id: userExperienceId,
        title: userExperiences[userExperienceId]?.title,
      },
    };
  }),
});
